const UnselectedFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/unselectedFilter/unselectedFilter.tpl.html',
    controller: 'unselectedFilterController',
    bindings: {
        filterModel: '<',
        advancedFilterType: '<',
        translationsKey: '<?'
    }
};

angular.module('umCore')
    .component('uiUnselectedFilter', UnselectedFilterComponent);
